import request from '@/utils/request'

//收益统计

export function getIncomeRanking(params) {
  return request({
    url: '/dashboard/v3/myStation/incomeRanking',
    method: 'get',
    params
  })
}

//收益和电量统计
export function getIncomeStations(params) {
  return request({
    url: '/dashboard/v3/myStation/incomeAndPower',
    method: 'get',
    params
  })
}